import React from 'react';
import { Box } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';
import {
  signalBorders,
  signalFonts,
  signalRadii,
  signalText,
} from '@/theme/foundations/tokens';
import { Mono } from '@/common/components/signal';
import { findSignalScreen } from './screens/registry';

/** Renders one Signal surface, or a placeholder if it has not been built yet. */
export const SignalScreenPage: React.FC = () => {
  const { screenId } = useParams();
  const screen = findSignalScreen(screenId);

  if (!screen) return <Navigate to="/signal" replace />;

  const { Component } = screen;

  return (
    <Box
      data-testid={`signal-screen-${screen.id}`}
      sx={{ padding: '40px 44px 100px' }}
    >
      {Component ? (
        <Component />
      ) : (
        <Box
          sx={{
            border: `1px dashed ${signalBorders.dashed}`,
            borderRadius: `${signalRadii['3xl']}px`,
            padding: '64px 40px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            textAlign: 'center',
          }}
        >
          <Mono
            size={11}
            weight={600}
            letterSpacing="0.12em"
            color={signalText.faint}
          >
            {screen.index} · NOT BUILT YET
          </Mono>
          <Box
            sx={{
              fontFamily: signalFonts.display,
              fontWeight: 700,
              fontSize: '24px',
              letterSpacing: '-0.02em',
            }}
          >
            {screen.title}
          </Box>
          <Box
            sx={{
              fontSize: '13px',
              color: signalText.secondary,
              maxWidth: '46ch',
              lineHeight: 1.6,
            }}
          >
            {screen.summary}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SignalScreenPage;
